import type { FaireProductEntity } from "../../entity_types/product";

export const p_jp6ctr42uh: FaireProductEntity = {
  token: "p_jp6ctr42uh",
  type: "product",
  name: "Purple Flowers Thinking of You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f40997ef0791e139c3ce4c6e2a7e29a50f902896132b761158ada0e89b9cee0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0ea90b5b5a77ab6ca1af89f027a4fde2f002a5c59253c03b6553a7389df153c.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:28.413Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
